import type { DateString } from '@web-platform/shared-universal-types/src/dateString';
import type { PartialSearchParams } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';
import type { Maybe } from '@web-platform/shared-universal-types-utils/src/utils';
// TODO: DINGO-2023 This should be replaced by the equivalent selector
export const getInboundDate = (userSearch: PartialSearchParams): Maybe<DateString> => {
  if (!Array.isArray(userSearch.legs) || userSearch.legs.length !== 1) {
    return undefined;
  }

  return userSearch.legs[0].return_date;
};
// TODO: DINGO-2023 This should be replaced by the equivalent selector
export const getOutboundDate = (userSearch: PartialSearchParams): DateString | undefined => {
  if (!Array.isArray(userSearch.legs) || userSearch.legs.length !== 1) {
    return undefined;
  }

  return userSearch.legs[0].date;
};

export const getIsAnytime = (userSearch: PartialSearchParams): boolean | undefined => {
  if (!Array.isArray(userSearch.legs) || userSearch.legs.length !== 1) {
    return false;
  }

  return userSearch.legs[0].is_anytime;
};
